import React, { useContext } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { Text } from 'rebass'
import { NavLink } from 'react-router-dom'

import useYam from '../../hooks/bakery/useYam'
import { ExternalLink } from '../../theme'
import { CONTRACT_ADDRESSES } from '../../constants/api'
import { useActiveWeb3React } from '../../hooks'
 import { userNftAddress } from '../../userType/userNftAddress'

const InfoBox = styled.div`
  margin-bottom: 28px;
  padding: 0 24px;
  width: 100%;
  height: 141px;
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    justify-content: center;
  `}
  .item{
    margin-top: 20px;
    display: flex;
    line-height: 16px;
  }
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    margin-top: 20px;
    width: 100%;
  `}
`
const AboutLink = styled(ExternalLink)`
  color: ${({ theme}) => theme.bsText28};
  text-decoration: none;
  font-family: 'Roboto-Medium';
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 0;
    margin-right: 8px;
  `};
`

const NavItem = styled(NavLink)`
  color: ${({ theme}) => theme.bsText28};
  text-decoration: none;
  font-family: 'Roboto-Medium';
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-left: 0;
    margin-right: 8px;
  `};
`

export interface ArtworkProps {
  tokenId: string
  owner?: string
  nftType?: number
  creator?: string
}

function dealToken (address: any) {
  if (address) {
    return address.substring(0, 8) + '...' + address.substring(34)
  }
  return '-'
}


export default function InfoAddress ({artwork, type}: {artwork: ArtworkProps, type: string}) {
  const theme = useContext(ThemeContext)
  const sushi = useYam()
  const { chainId } = useActiveWeb3React()
  const bscLink = CONTRACT_ADDRESSES.bscApi[chainId as number]
  let contractId = userNftAddress(sushi, type)
  
  return (
    <>
      <InfoBox>
        {/* <div className={'item'} style={{margin: '0 0 4px', lineHeight: '25px'}}>
          <Text fontFamily="Roboto" fontWeight={700} fontSize={20} color={theme.bsText28}>Details</Text>
        </div> */}
        <div className={'item'}>
          <Text fontFamily="Roboto-Medium" fontSize={14} color={theme.bsText29}>Token ID :</Text>
          <Text fontWeight={500} fontSize={14} color={theme.bsText28} marginLeft="8px" maxWidth='80%'>
            <AboutLink href={`${bscLink}/token/${contractId}?a=${artwork.tokenId}`}>
              { artwork.tokenId }
            </AboutLink>
          </Text>
        </div>
        <div className={'item'}>
          <Text fontFamily="Roboto-Medium" fontSize={14} color={theme.bsText29}>NFT Contract ID :</Text>
          <Text fontWeight={500} fontSize={14} color={theme.bsText28} marginLeft="8px">
            <AboutLink style={{color: theme.bsText28}} href={`${bscLink}/token/${contractId}`}>
              { dealToken(contractId) }
            </AboutLink>
          </Text>
        </div>
        <div className={'item'}>
          <Text fontFamily="Roboto-Medium" fontSize={14} color={theme.bsText29}>Creator's Address :</Text>
          <Text fontWeight={500} fontSize={14} color={theme.bsText28} marginLeft="8px">
            <NavItem to={`/usercenter/${artwork.creator}?type=CREATED`}>
              { dealToken(artwork.creator) }
            </NavItem>
          </Text>
        </div>
        <div className={'item'}>
          <Text fontFamily="Roboto-Medium" fontSize={14} color={theme.bsText29}>Owner's Address :</Text>
          <Text fontWeight={500} fontSize={14} color={theme.bsText28} marginLeft="8px">
            <NavItem to={`/usercenter/${artwork.owner}?type=COLLECTED`}>
              { dealToken(artwork.owner) }
            </NavItem>
          </Text>
        </div>
        {/* <InfoCard width={'100%'} style={{marginTop: '16px'}}>
          <div className={'item default'}>
            <Text fontWeight={700} fontSize={14} color={theme.text1}>Bscscan Link :</Text>
            <Text fontWeight={700} fontSize={14} color={theme.bsText3} marginLeft={'10px'}>
              <a style={{color: theme.bsText3, textDecoration: 'none'}} href="https://www.bscscan.com" target='_blank' rel="noopener noreferrer">www.bscscan.com</a>
              <img style={{margin: '0px 0px -2px 5px'}} src='/images/bakery/icon_open_link_brown.svg' alt="" />
            </Text>
          </div>
        </InfoCard> */}
      </InfoBox>
    </>
  )
}
